import React from 'react';
import { Grid } from '@mui/material';
import { SummedReport } from '../../../models/ReportData';
import { Spacer } from '../../../components';
import ActiveUsers from '../ReportUserAccounts/ActiveUsers';
import PaymentPlatformChart from './PaymentPlatformChart';
import CreationMethodChart from './CreationMethodChart';
import PrimaryPlatformChart from './PrimaryPlatformChart';
import LoginCountChart from './LoginCountChart';
import EmptyReport from '../EmptyReport';

interface ReportUserDataProps {
  summedReport: SummedReport | null;
}

const ReportUserData: React.FC<ReportUserDataProps> = ({ summedReport }) => {
  if (!summedReport) return <EmptyReport />;

  return (
    <>
      <Grid container flexDirection='row'>
        <ActiveUsers summedReport={summedReport} />
      </Grid>

      <Spacer height='md' />

      <Grid display='flex' flexDirection='row' justifyContent='space-between' margin='0 auto'>
        <Grid width='100%'>
          <PaymentPlatformChart summedReport={summedReport} />
        </Grid>
        <Spacer width='xxl' />
        <Grid width='100%'>
          <CreationMethodChart summedReport={summedReport} />
        </Grid>
      </Grid>

      <Spacer height='md' />

      <Grid display='flex' flexDirection='row' justifyContent='space-between' margin='0 auto'>
        <Grid width='100%'>
          <PrimaryPlatformChart summedReport={summedReport} />
        </Grid>
        <Spacer width='xxl' />
        <Grid width='100%'>
          <LoginCountChart summedReport={summedReport} />
        </Grid>
      </Grid>
    </>
  );
};

export default ReportUserData;
